import { SidebarMenuItem } from './sidebar-menu-items';

export const SidebarMenuItems: SidebarMenuItem[] = [

    //DAM
    {
        path: '',
        title: 'D.A.M',
        icon: 'far fa-photo-video icon',
        class: 'has-arrow',
        extralink: false,
        submenu: [
            {
                path: 'dam/immagini',
                title: 'Immagini',
                icon: '',
                class: '',
                extralink: false,
                submenu: [],
            },
            {
                path: 'dam/gallerie',
                title: 'Gallerie',
                icon: '',
                class: '',
                extralink: false,
                submenu: [],
            },
            {
                path: 'dam/documenti',
                title: 'Documenti',
                icon: '',
                class: '',
                extralink: false,
                submenu: [],
            },
        ]
    },
    //Store
    {
        path: '',
        title: 'Store',
        icon: 'far fa-shopping-basket icon',
        class: 'has-arrow',
        extralink: false,
        submenu: [
            {
                path: 'store/store',
                title: 'Store',
                icon: '',
                class: '',
                extralink: false,
                submenu: [],
            },
            {
                path: 'store/store-prenotaeritira',
                title: 'Store C&C',
                icon: '',
                class: '',
                extralink: false,
                submenu: [],
            },
            {
                path: 'store/promo',
                title: 'Promozione ed Eventi',
                icon: '',
                class: '',
                extralink: false,
                submenu: [],
            },
            {
                path: 'store/prodotti',
                title: 'Prodotti e Servizi',
                icon: '',
                class: '',
                extralink: false,
                submenu: [],
            },
            {
                path: 'store/gestioneorari',
                title: 'Gestione orari',
                icon: '',
                class: '',
                extralink: false,
                submenu: [],
            },
            {
                path: 'store/accessoristore',
                title: 'Accessori store',
                icon: '',
                class: '',
                extralink: false,
                submenu: [],
            },
            {
                path: 'store/contattistoremanager',
                title: 'Contatti store manager',
                icon: '',
                class: '',
                extralink: false,
                submenu: [],
            }
        ],
    },
    //Appuntamenti
    {
        path: '',
        title: 'Appuntamenti',
        icon: 'far fa-calendar icon',
        class: 'has-arrow',
        extralink: false,
        submenu: [
            {
                path: 'appointment/calendar',
                title: 'Appuntamenti',
                icon: '',
                class: '',
                extralink: false,
                submenu: [],
            },
            {
                path: 'appointment/topic-management',
                title: 'Gestione argomenti',
                icon: '',
                class: '',
                extralink: false,
                submenu: [],
            },
            {
                path: 'appointment/appointment-times',
                title: 'Orari appuntamenti',
                icon: '',
                class: '',
                extralink: false,
                submenu: [],
            },
            {
                path: 'appointment/export-csv-email-lists',
                title: 'Liste Email Export Csv',
                icon: '',
                class: '',
                extralink: false,
                submenu: [],
            }
        ],
    },
    //Prenota e ritira
    {
        path: '',
        title: 'Prenota e ritira',
        icon: 'far fa-clock icon',
        class: 'has-arrow',
        extralink: false,
        submenu: [
            {
                path: 'clickandcollect/sim',
                title: 'SIM',
                icon: '',
                class: '',
                extralink: false,
                submenu: [],
            },
            {
                path: 'clickandcollect/smartphone',
                title: 'SMARTPHONE',
                icon: '',
                class: '',
                extralink: false,
                submenu: [],
            }
        ],
    },
    //Digital coupon
    {
        path: 'digitalcoupon',
        title: 'Digital coupon',
        icon: 'far fa-solid fa-gift icon',
        class: '',
        extralink: false,
        submenu: [],
    },
    //Pagine Custom
    {
        path: '',
        title: 'Pagine Custom',
        icon: 'far fa-window-maximize icon',
        class: 'has-arrow',
        extralink: false,
        submenu: [
            {
                path: 'custompage/custompage',
                title: 'Contenuti custom',
                icon: '',
                class: '',
                extralink: false,
                submenu: [],
            },
            {
                path: 'custompage/shopping-center',
                title: 'Centri commerciali',
                icon: '',
                class: '',
                extralink: false,
                submenu: [],
            },
            {
                path: 'custompage/news-filters',
                title: 'Filtri news',
                icon: '',
                class: '',
                extralink: false,
                submenu: [],
            },
            {
                path: 'custompage/activity-map',
                title: 'Attività',
                icon: '',
                class: '',
                extralink: false,
                submenu: [],
            }
        ],
    },
    //Reseller
    {
        path: 'reseller',
        title: 'Reseller',
        icon: 'fas fa-store-alt icon',
        class: '',
        extralink: false,
        submenu: [],
    },
    //Header
    {
        path: 'header',
        title: 'Header',
        icon: '',
        image: '/assets/images/header.svg',
        imageclass: 'svg-inline--fa fa-w-16 icon',
        class: '',
        extralink: false,
        submenu: [],
    },
    //Footer
    {
        path: 'footer',
        title: 'Footer',
        icon: '',
        image: '/assets/images/footer.svg',
        imageclass: 'svg-inline--fa fa-w-16 icon',
        class: '',
        extralink: false,
        submenu: [],
    },
    //Subfooter
    {
        path: '/subfooter',
        title: 'Subfooter',
        icon: '',
        image: '/assets/images/subfooter.svg',
        imageclass: 'svg-inline--fa fa-w-16 icon',
        class: '',
        extralink: false,
        submenu: [],
    },
    //Admin
    {
        path: '',
        title: 'Admin',
        icon: '',
        image: '/assets/images/admin.svg',
        imageclass: 'svg-inline--fa fa-w-16 icon',
        class: '',
        extralink: false,
        submenu: [
            {
                path: 'admin/user',
                title: 'User',
                icon: '',
                class: '',
                extralink: false,
                submenu: [],
            },
            {
                path: 'admin/supervisori',
                title: 'Supervisori',
                icon: '',
                class: '',
                extralink: false,
                submenu: [],
            },
        ],
    },
    //XML
    {
        path: '/xml-2',
        title: 'XML - 2',
        icon: 'far fa-solid fa-file icon',
        extralink: false,
        class: '',
        submenu: [],
    },
    //XML store-rossi
    {
        path: '/xml-red',
        title: 'XML - Red',
        icon: 'far fa-solid fa-file icon',
        extralink: false,
        class: '',
        submenu: [],
    },
];
